import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useShowAlert } from "../../../context/AlertContext";
import Messages from "../../../constants/Messages";
import { useAuth } from "../../../context/AuthProvider";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { usePermission } from "../../../context/PermissionContext";
import { useContextApi } from "../../../context/ContextApi";
import uRLs from "../../../utils/baseUtils";
import { toSecondaryQuantity } from "@heartinz/finance";
import { handleChange } from "../../../utils/ProductHandleChange";
import { secondaryQuanity } from "../../../utils/ProductHandleChange";
import { CheckIcon, XIcon } from "../../../constants/Icons";

const EditStock = ({ isActive, editData, onClose, onEdit, isBtnLoading }) => {
  const { isUser, settings } = useAuth();
  const serverTime = GetServerLiveTime();
  const { viewOption } = usePermission();
  const { useEscapeKey } = useContextApi();
  useEscapeKey(onClose);
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const [selectedUnit, setSelectedUnit] = useState();
  const productMrpRef = useRef(null);
  const productsalepriceRef = useRef(null);
  const producttaxpercentageRef = useRef(null);
  const productbasepriceRef = useRef(null);
  const productLandingCostRef = useRef(null);
  const manufacturedateRefs = useRef(null);
  const productStockCostRef = useRef(null);
  const expiredateRefs = useRef(null);
  const updateBtnRef = useRef(null);
  const popupMrpInputRef = useRef(null);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});
  const modalBodyRef = useRef(null);
  const iso = serverTime.toISOString();
  const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
  const [manufacturedate, setMDate] = useState("");
  const [expiredate, setEDate] = useState("");
  const [expireMinDate, setExpireMinDate] = useState(iso);
  const mfgDateWrapperRef = useRef(null);
  const expDateWrapperRef = useRef(null);

  const [openMfgDate, setOpenMfgDate] = useState(false);
  const [openExpDate, setOpenExpDate] = useState(false);

  const handleMDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setProductData((prev) => ({
      ...prev,
      manufacturedate: indiaTime,
    }));

    setMDate(indiaTime);
    setExpireMinDate(indiaTime);
  };

  const handleEDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setProductData((prev) => ({
      ...prev,
      expiredate: indiaTime,
    }));
    setEDate(indiaTime);
  };

  const [openPicker, setOpenPicker] = useState(null);
  // 'mfg' | 'exp' | null

  const [isSelectedRadio, setSelectedRadio] = useState("SALEPRICE");
  const [isProductData, setProductData] = useState({
    mrp: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    landingcost: "",
    stock: "",
  });


const allUnits = [
  ...(settings?.defaultUnits || []).map((u) => ({
    unitCode: u.unitCode,
    unitName: u.unitName,
  })),
  ...(settings?.storeUnits || []).map((u) => ({
    unitCode: u.unitCode,
    unitName: u.unitName,
  })),
];

const targetUnitCode = isProductData?.isSecondaryUnit
  ? isProductData?.unitConfig?.secondaryUnitCode
  : isProductData?.unitConfig?.primaryUnitCode;

  const defaultConversion = allUnits?.find(
    (u) => u?.unitCode === targetUnitCode,
  );

  
  const [error, setErrors] = useState({});

  const showAlert = useShowAlert();

  const handleCalculate = (updatedData) => {
    var { mrp, saleprice, baseprice, taxpercentage } = updatedData;
    let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
    let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
    let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
    let numericTaxpercentage = parseInt(taxpercentage);
    let quanity = parseInt(1);
    let calculationResult;
    let lock = isSelectedRadio;
    try {
      calculationResult = priceCalculator.getAllPriceList(
        numericMrp,
        numericSaleprice,
        numericBaseprice,
        numericTaxpercentage,
        quanity,
        lock,
      );

      if (lock === "SALEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            baseprice: CurrencyConverter.toCurrency(
              calculationResult.basePrice,
              "INR",
            ),
          }));
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            calculationResult.basePrice,
            "INR",
          ),
        }));
      } else if (lock === "BASEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            saleprice: CurrencyConverter.toCurrency(
              calculationResult.salePrice,
              "INR",
            ),
          }));
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            calculationResult.salePrice,
            "INR",
          ),
        }));
      }
    } catch (error) {
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  // const handleChange = (e) => {
  //   setErrors("");
  //   const { name, value } = e.target;
  //   let inputValue = value;
  //   if (
  //     name === "saleprice" ||
  //     name === "baseprice" ||
  //     name === "landingcost" ||
  //     name === "mrp"
  //   ) {
  //     const regex = /^$|^\d*\.?\d{0,2}$/;
  //     if (!regex.test(value)) {
  //       return;
  //     }
  //     inputValue = value;
  //   }
  //   if (name === "taxpercentage") {
  //     const allowedValues = [0, 5, 12, 18, 24];
  //     if (!allowedValues.includes(Number(value))) inputValue = 0;
  //   }
  //   if (["stock"].includes(name)) {
  //     if (
  //       uRLs.UNIT === "true" &&
  //       (isProductData?.stockLeftUnit || isProductData?.unitConfig)
  //     ) {
  //       // allow decimal with max 3 digits
  //       if (isProductData?.isSecondaryUnit) {
  //         if (!/^\d*\.?\d{0,1}$/.test(value)) {
  //           return;
  //         }
  //       } else {
  //         // primary unit -> allow 3 decimals
  //         if (!/^\d*\.?\d{0,3}$/.test(value)) {
  //           return;
  //         }
  //       }
  //     } else {
  //       // allow only integer
  //       if (!/^\d*$/.test(value)) {
  //         return;
  //       }
  //     }
  //   }
  //   const updatedData = {
  //     ...isProductData,
  //     [name]: inputValue,
  //   };
  //   setProductData(updatedData);
  //   handleCalculate(updatedData);
  // };

  const changeParams = {
    isProductData,
    uRLs,       // ← activates Variant D mode
    clearErrorsOnChange: true,
    setProductData,
    setErrors,
    handleCalculate,
    validateField: () => {}, // not used in D but required to avoid crash
  };

  const handleRadioChange = (inputName) => {
    setSelectedRadio(inputName);
  };

  const validateForm = () => {
    const errors = {};

    if (
      isProductData.saleprice === undefined ||
      isProductData.saleprice === null ||
      isProductData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
      productsalepriceRef.current?.focus();
    } else if (
      isProductData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
      productsalepriceRef.current?.focus();
    } else if (
      isProductData.taxpercentage === undefined ||
      isProductData.taxpercentage === null ||
      isProductData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
      producttaxpercentageRef.current?.focus();
    } else if (
      isProductData.taxpercentage &&
      !/^[0-9]*$/.test(isProductData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
      producttaxpercentageRef.current?.focus();
    } else if (
      isProductData.baseprice === undefined ||
      isProductData.baseprice === null ||
      isProductData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
      productbasepriceRef.current?.focus();
    } else if (
      isProductData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
      productbasepriceRef.current?.focus();
    } else if (
      isProductData.taxamount === undefined ||
      isProductData.taxamount === null ||
      isProductData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      isProductData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    } else if (isProductData.stock !== "" && Number(isProductData.stock) <= 0) {
      errors.stock = "Stock must be greater than 0";
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "saleprice":
          productsalepriceRef.current?.focus();
          break;
        case "taxpercentage":
          producttaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          productbasepriceRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleClose = () => {
    onClose();
  };

  const stopEventPropagation = (e) => e.stopPropagation();

  const isValidDate = (date) => {
    const d = new Date(date);
    return !isNaN(d.getTime());
  };
  const handleEdit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const updatedData = {
      ...isProductData,
      stock: Number(isProductData.stock),
      manufacturedate: isValidDate(manufacturedate)
        ? new Date(manufacturedate).toISOString()
        : null,
      expiredate: isValidDate(expiredate)
        ? new Date(expiredate).toISOString()
        : null,
      isLock: isSelectedRadio,
    };
    onEdit(updatedData);
  };

  useEffect(() => {
    if (!isActive || !editData) return;

    if (showMrpPopup) return;

    const timer = setTimeout(() => {
      productMrpRef.current?.focus();
    }, 100); // allow modal to render

    return () => clearTimeout(timer);
  }, [isActive, editData, showMrpPopup]);

  useEffect(() => {
    if (editData) {
      if (!editData.isLock) {
        editData.isLock = "SALEPRICE";
      }

      if (editData?.manufacturedate) {
        const dateM = new Date(editData?.manufacturedate);
        const isoM = dateM.toISOString();
        const indiaM = DateConverter.convertToTimeZone(isoM, "Asia/Kolkata");

        setMDate(indiaM);
      }
      setProductData(editData);
      if (editData?.expiredate) {
        const dateE = new Date(editData?.expiredate);
        const isoE = dateE.toISOString();
        const indiaE = DateConverter.convertToTimeZone(isoE, "Asia/Kolkata");
        setEDate(indiaE);
      }
      setSelectedRadio(editData.isLock);
    }
  }, [editData]);

  const handleFieldFocus = (e) => {
    e.target.select?.();
    setOpenPicker(null);
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const trimmedData = String(isProductData[fieldName] || "").trim();
      // const requiredFields = ["saleprice", "taxpercentage"];

      // if (requiredFields.includes(fieldName) && !trimmedData) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     [fieldName]:
      //       Messages.ERROR[`${fieldName.toUpperCase()}_EMPTY`] || "Required",
      //   }));
      //   return;
      // }

      if (isLast) {
        handleEdit(e);
      } else {
        const nextInput =
          nextRef?.current?.input ||
          nextRef?.current?.flatpickr?.input ||
          nextRef?.current?.querySelector?.("input") ||
          nextRef?.current;

        if (nextInput && typeof nextInput.focus === "function") {
          nextInput.focus();
        } else {
          console.warn("Cannot focus nextRef:", nextRef);
        }
      }
    }
  };

 

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="StockModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        // onClick={handleClose}
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
          // onClick={stopEventPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Edit Stock</h6>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body bg-light">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-lg-12 mt-3">
                      <div className="card shadow-none border-blue mb-0">
                        <div className="card-header bg-light-blue p-2">
                          <div className="mb-0">Product info</div>
                        </div>
                        {isProductData ? (
                          <>
                            {/* <p className="mb-1">
                              Title:{" "}
                              <span className="fw-600">
                                {isProductData?.title}
                              </span>
                            </p>
                            <p className="mb-1">
                              HSN :{" "}
                              {isProductData?.hsnsac ? (
                                <span className="fw-600">
                                  {isProductData?.hsnsac}
                                </span>
                              ) : (
                                <>-</>
                              )}
                            </p> */}
                            {/* <p className="mb-1">
                              SalePrice:{" "}
                              <span className="fw-600">
                                ₹{isProductData.saleprice || 0}{" "}
                              </span>
                            </p> */}
                            <div className="card-body p-2">
                              <div className="d-flex fs-13">
                                <div
                                  className="mb-1 d-flex  gap-2"
                                  style={{ flexBasis: "100%" }}
                                >
                                  <span className="fw-semibold text-muted">
                                    Title:
                                  </span>
                                  {isProductData?.title ? (
                                    <span className="fw-600 ">
                                      {isProductData?.title}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </div>
                              <div className="d-flex fs-13">
                                <div
                                  className="mb-1 d-flex align-items-center gap-2"
                                  style={{ flexBasis: "50%" }}
                                >
                                  <span className="fw-semibold text-muted">
                                    SKU Code:
                                  </span>
                                  {isProductData?.code ? (
                                    <span className="badge rounded-pill bg-label-navy">
                                      {isProductData?.code}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                                <div
                                  className="mb-1 d-flex align-items-center gap-2"
                                  style={{ flexBasis: "50%" }}
                                >
                                  <span className="fw-semibold text-muted">
                                    HSN:
                                  </span>
                                  {isProductData?.hsnsac ? (
                                    <span className="badge rounded-pill bg-label-retro">
                                      {isProductData.hsnsac}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </div>
                              <div className="d-flex fs-13">
                                <div
                                  className="mb-1 d-flex align-items-center gap-2"
                                  style={{ flexBasis: "50%" }}
                                >
                                  <span className="fw-semibold text-muted">
                                    Brand:
                                  </span>
                                  {isProductData?.brandId ? (
                                    <span className="badge bg-label-kids">
                                      {isProductData?.brandId}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                                <div
                                  className="mb-1 d-flex align-items-center gap-2"
                                  style={{ flexBasis: "50%" }}
                                >
                                  <span className="fw-semibold text-muted">
                                    Stock Left:
                                  </span>
                                  {isProductData.stockLeft ? (
                                    <span className="badge bg-label-space">
                                      {Number(isProductData?.isSecondaryUnit
                                    ? secondaryQuanity(isProductData.stockLeft,isProductData?.unitConfig)
                                    : isProductData?.stockLeft)}
                                    <span className="font-11 ms-1">{defaultConversion?.unitCode}</span>
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </div>
                              <div className="d-flex fs-13">
                                <div
                                  className="mb-1 d-flex align-items-center gap-2"
                                  style={{ flexBasis: "50%" }}
                                >
                                  <span className="fw-semibold text-muted">
                                    Note:
                                  </span>
                                  {isProductData?.note ? (
                                    <span className="badge bg-label-sun">
                                      {isProductData?.note}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                                {uRLs.UNIT === "true" && (
                                  <div
                                    className="mb-2 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">
                                      Unit:
                                    </span>
                                    {defaultConversion?.unitName ? (
                                      <span className="badge rounded-pill btn-unit">
                                        {defaultConversion?.unitName}{" "} 
                                    (
                                        {defaultConversion?.unitCode})
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <p className="mb-1 text-muted">
                            No products has been selected
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-12 border-top ">
                          <div className="fw-600 mt-2">
                            Amount {isProductData?.unitConfig?.primaryUnitCode ? 
                              (<span className="">
                                  (Per {isProductData?.unitConfig?.primaryUnitCode})
                                </span>
                              ) : ("")}
                          </div>
                        </div>
                    <div className="col-lg-4">
                      <label htmlFor="mrp" className="form-label">
                        {" "}
                        MRP{" "}
                      </label>
                      {!showMrpPopup && (
                        <input
                          type="text"
                          className="form-control"
                          name="mrp"
                          autoComplete="off"
                          autoFocus
                          ref={productMrpRef}
                          value={isProductData.mrp}
                          onFocus={handleFieldFocus}
                          onChange={(e) => handleChange(e, changeParams)}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "mrp", productsalepriceRef)
                          }
                          onClick={() => {
                            const rect =
                              productMrpRef.current.getBoundingClientRect();
                            setPopupMrpStyle({
                              position: "absolute",
                              top: `${rect.top + window.scrollY}px`,
                              left: `${rect.left + window.scrollX}px`,
                              width: `${rect.width}px`,
                              zIndex: 10000,
                            });
                            setPopupMrpValue(isProductData.mrp);
                            setShowMrpPopup(true);
                          }}
                        />
                      )}
                      {showMrpPopup && (
                        <input
                          type="text"
                          ref={popupMrpInputRef}
                          value={popupMrpValue}
                          onChange={(e) => {
                            const val = e.target.value;
                            const regex = /^\d+(\.\d{0,2})?$/;
                          if (val === "" || regex.test(val)) {
                            setPopupMrpValue(val);
                            setProductData((prev) => ({ ...prev, mrp: val }));
                            handleCalculate({ ...isProductData, mrp: val });
                          }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setShowMrpPopup(false);
                              setTimeout(() => {
                                productsalepriceRef?.current?.focus();
                              }, 0);
                            }
                          }}
                          onBlur={() => setShowMrpPopup(false)}
                          onFocus={handleFieldFocus}
                          // style={popupMrpStyle}
                          className="form-control"
                        />
                      )}
                      {error.mrp && (
                        <div className="invalid-feedback">{error.mrp}</div>
                      )}
                    </div>

                    <div className="col-lg-4">
                      <label htmlFor="saleprice" className="form-label">
                        Sale Price <span className="text-danger">*</span>
                      </label>

                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="saleprice"
                          autoComplete="off"
                          ref={productsalepriceRef}
                          value={isProductData.saleprice}
                          className="form-control"
                          onFocus={handleFieldFocus}
                          onClick={() => handleRadioChange("SALEPRICE")}
                          style={{ paddingLeft: "30px" }}
                          onChange={(e) => handleChange(e, changeParams)}
                          onKeyDown={(e) =>
                            handleEnterKey(
                              e,
                              "saleprice",
                              producttaxpercentageRef,
                            )
                          }
                        />
                        <input
                          type="radio"
                          name="selectInput"
                          checked={isSelectedRadio === "SALEPRICE"}
                          className="position-absolute"
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                          }}
                        />
                      </div>
                      {error.saleprice && (
                        <div className="invalid-feedback">
                          {error.saleprice}
                        </div>
                      )}
                    </div>

                    <div className="col-lg-4">
                      <label htmlFor="FisrtName" className="form-label">
                        Tax(%) <span className="text-danger">*</span>
                      </label>
                      <select
                        name="taxpercentage"
                        className="form-select"
                        ref={producttaxpercentageRef}
                        value={isProductData.taxpercentage}
                        onChange={(e) => handleChange(e, changeParams)}
                        onKeyDown={(e) =>
                          handleEnterKey(
                            e,
                            "taxpercentage",
                            productbasepriceRef,
                          )
                        }
                      >
                        <option value="0">0</option>
                        <option value="5">5</option>
                        <option value="12">12</option>
                        <option value="18">18</option>
                        <option value="24">24</option>
                      </select>
                    </div>

                    <div className="col-lg-4">
                      <label htmlFor="discount" className="form-label">
                        Discount
                      </label>
                      <input
                        readOnly=""
                        type="text"
                        name="discount"
                        autoComplete="off"
                        value={isProductData.discount}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <div className="col-lg-4">
                      <label htmlFor="baseprice" className="form-label">
                        Base Price
                      </label>

                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="baseprice"
                          autoComplete="off"
                          ref={productbasepriceRef}
                          onClick={() => handleRadioChange("BASEPRICE")}
                          onChange={(e) => handleChange(e, changeParams)}
                          value={isProductData.baseprice}
                          onFocus={handleFieldFocus}
                          className="form-control"
                          style={{ paddingLeft: "30px" }}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "baseprice", manufacturedateRefs)
                          }
                        />
                        <input
                          type="radio"
                          name="selectInput"
                          className="position-absolute"
                          checked={isSelectedRadio === "BASEPRICE"}
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                          }}
                        />
                      </div>
                      {error.baseprice && (
                        <div className="invalid-feedback">
                          {error.baseprice}
                        </div>
                      )}
                    </div>

                    <div className="col-lg-4">
                      <label htmlFor="taxamount" className="form-label">
                        Tax Amount
                      </label>

                      <input
                        readOnly=""
                        type="text"
                        name="taxamount"
                        autoComplete="off"
                        className="form-control"
                        value={isProductData.taxamount}
                        disabled
                      />
                    </div>
                    <div className="col-12 border-top"></div>
                    {viewOption(
                      "stockSettings",
                      "isManufactureAndExpiryDates",
                    ) && (
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="col-lg-6">
                            <label className="form-label">
                              Manufacture Date
                            </label>

                            <DatePicker
                              open={openMfgDate}
                              onOpen={() => setOpenMfgDate(true)}
                              onClose={() => setOpenMfgDate(false)}
                              disableOpenPicker
                              value={
                                isProductData?.manufacturedate
                                  ? dayjs(isProductData.manufacturedate)
                                  : null
                              }
                              format="DD MMM YYYY"
                              maxDate={dayjs(iso)}
                              onChange={(newValue) => {
                                if (!newValue) return;
                                handleMDateChange(newValue);
                                setOpenMfgDate(false); // ✅ close even if date not picked later
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                  onClick: () => setOpenMfgDate(true),
                                  inputProps: { readOnly: true },
                                  onKeyDown: (e) => e.preventDefault(),
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                                openPickerButton: { sx: { display: "none" } },
                              }}
                            />
                          </div>

                          <div className="col-lg-6">
                            <label className="form-label">Expire Date</label>

                            <DatePicker
                              open={openExpDate}
                              onOpen={() => setOpenExpDate(true)}
                              onClose={() => setOpenExpDate(false)}
                              disableOpenPicker
                              value={
                                isProductData?.expiredate
                                  ? dayjs(isProductData.expiredate)
                                  : null
                              }
                              format="DD MMM YYYY"
                              minDate={dayjs(expireMinDate)}
                              onChange={(newValue) => {
                                if (!newValue) return;
                                handleEDateChange(newValue);
                                setOpenExpDate(false);
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                  onClick: () => setOpenExpDate(true),
                                  inputProps: { readOnly: true },
                                  onKeyDown: (e) => e.preventDefault(),
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                                openPickerButton: { sx: { display: "none" } },
                              }}
                            />
                          </div>
                        </LocalizationProvider>
                      </>
                    )}
                    {/*                     
                    <div className="col-lg-6">
                      <div className="d-flex align-items-center">
                        <label htmlFor="landingcost" className="form-label">
                          Landing Cost <small>(Per Unit) (Optional)</small>
                        </label>
                        <span className="tooltip-container">
                          <span className="tooltip-icon">?</span>
                          <span className="tooltip-text">
                            Total cost to bring the product to your inventory,
                            including purchase price and taxes.
                          </span>
                        </span>
                      </div>
                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="landingcost"
                          autoComplete="off"
                          ref={productLandingCostRef}
                          value={isProductData.landingcost}
                          className="form-control"
                          onFocus={(e) => e.target.select()}
                          onChange={handleChange}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "landingcost", productStockCostRef)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="d-flex align-items-center align-items-center">
                        <label htmlFor="landingcost" className="form-label">
                          Stock 
                        </label>
                        
                      </div>
                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="stock"
                          autoComplete="off"
                          ref={productStockCostRef}
                          value={isProductData.stock}
                          className="form-control"
                          onFocus={(e) => e.target.select()}
                          onChange={handleChange}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "stock", null, true)
                          }
                        />
                      </div>
                    </div> */}
                    <>
                      <div className="col-6 d-flex align-items-center justify-content-start">
                        <label
                          htmlFor="finallandingcost"
                          className="form-label "
                        >
                          Landing Cost <small>(Per {isProductData?.unitConfig?.primaryUnitCode?isProductData?.unitConfig?.primaryUnitCode:"Unit"}) (Optional)</small>
                          <span className="tooltip-container ms-1">
                            <span className="tooltip-icon">?</span>
                            <span className="tooltip-text">
                              Total cost to bring the product to your inventory,
                              including purchase price and taxes.
                            </span>
                          </span>
                        </label>
                      </div>
                      <div className="col-6 d-flex align-items-end justify-content-start">
                        <label
                          htmlFor="stock"
                          className="form-label "
                        >
                          Stock{" "}
                          <span className="badge bg-label-space ms-2">
                          {Number(isProductData?.isSecondaryUnit
                                    ? secondaryQuanity(isProductData.stockLeft,isProductData?.unitConfig)
                                    : isProductData?.stockLeft)}
                                    <span className="font-11 ms-1">{defaultConversion?.unitCode}</span>
                          </span>
                        </label>
                      </div>
                    </>
                    <>
                      <div className="col-6 mt-0">
                        <input
                          type="text"
                          name="landingcost"
                          autoComplete="off"
                          ref={productLandingCostRef}
                          value={isProductData.landingcost}
                          className="form-control"
                          onFocus={(e) => e.target.select()}
                          onChange={(e) => handleChange(e, changeParams)}
                          onKeyDown={(e) =>
                            handleEnterKey(
                              e,
                              "landingcost",
                              productStockCostRef,
                            )
                          }
                        />
                      </div>
                      <div className="col-6 mt-0">
                        <div className="input-group">
                          <input
                            type="text"
                            name="stock"
                            autoComplete="off"
                            ref={productStockCostRef}
                            value={isProductData.stock}
                            className="form-control"
                            onFocus={(e) => e.target.select()}
                            onChange={(e) => handleChange(e, changeParams)}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "stock", null, true)
                            }
                          />
                          {/* {(uRLs.UNIT==="true" && (isProductData?.stockLeftUnit||isProductData?.unitConfig)) && (
                       <div className="d-flex text-start ">
                    <button
                          className="btn btn-unit shadow-none rounded-start-0  dropdown-toggle-split"
                          id="printreceiptbtn"
                          data-bs-toggle="dropdown"
                        >
                          {isProductData?.unitConfig ? isProductData.isSecondaryUnit? isProductData?.unitConfig?.secondaryUnitCode :isProductData?.unitConfig?.primaryUnitCode:isProductData?.stockLeftUnit}
                        </button>
                        </div>)} */}
                          {error.stock && (
                            <div className="invalid-feedback">
                              {error.stock}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={handleClose}
              >
                <XIcon/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-teal pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-teal text-right"
                  onClick={handleEdit}
                  ref={updateBtnRef}
                >
                  <CheckIcon/> Update Stock
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStock;
